{
  "translation": {
    "forgotPasswordTitle": "Forgot password",
    "forgotPasswordHeader": "Let’s find your account",
    "forgotPasswordDescription": "Enter the email you used to sign up so we can find your account.",
    "forgotPasswordEmailField": "Email address",
    "forgotPasswordNextButtonTitle": "Next",

    "confirmIdentityHeader": "Confirm your identity",
    "confirmIdentityDescription": "It’s for your security. Let us know if you prefer an email or text.",
    "confirmIdentityEmailSection": "Email",
    "confirmIdentityMessageSection": "Text message",
    "confirmIdentityButtonTitle": "I can’t access my account’s phone number or email"
  }
}
